import diedrichwilms from "../../../assets/image/lawyers/diedrich.webp";
import friedrichschulze from "../../../assets/image/lawyers/friedrich.webp";
import thorstenmuellerwinterhager from "../../../assets/image/lawyers/thorsten.webp";
import felixfreist from "../../../assets/image/lawyers/felix.webp";
import kathrinfreist from "../../../assets/image/lawyers/kathrin.webp";
import helenaKohlmann from "../../../assets/image/lawyers/helena.webp";
import { useEffect, useState } from "react";
import { Person } from "./lawyers/types";
import people from "./lawyers/list";
import { Area } from "../useAreas/areas/types";

const useLawyers = (idList?: string[], areaList?: Area[]) => {
  const [lawyers, setLawyers] = useState<{ image: string; person: Person }[]>();

  useEffect(() => {
    const images = [
      diedrichwilms,
      friedrichschulze,
      kathrinfreist,
      thorstenmuellerwinterhager,
      helenaKohlmann,
      felixfreist,
    ];

    if (!lawyers) {
      if (idList) {
        const filteredPeople = people.reduce((acc, person, i) => {
          if (idList.includes(person.id)) {
            acc.push({ person, image: images[i] });
          }
          return acc;
        }, []);
        setLawyers(filteredPeople);
      } else if (areaList) {
        const filteredPeople = people.reduce((acc, person, i) => {
          if (
            areaList.some(
              (a) => person.areas.includes(a) || person.subAreas.includes(a)
            )
          ) {
            acc.push({ person, image: images[i] });
          }
          return acc;
        }, []);
        setLawyers(filteredPeople);
      } else {
        setLawyers(people.map((p, i) => ({ image: images[i], person: p })));
      }
    }
  }, [lawyers, idList, areaList]);

  return lawyers;
};

export default useLawyers;
